import React from 'react';
import { BADGE_VARIANTS } from '../../config/designTokens';
interface BadgeProps {
  children: React.ReactNode;
  variant?: 'default' | 'primary' | 'secondary' | 'success' | 'warning' | 'danger' | 'info' | 'neutral' | 'outline';
  size?: 'sm' | 'md' | 'lg';
  icon?: React.ReactNode;
  className?: string;
}
export function Badge({
  children,
  variant = 'default',
  size = 'md',
  icon,
  className = ''
}: BadgeProps) {
  const variants = BADGE_VARIANTS;
  // IMPROVED: Larger sizes for better readability
  const sizes = {
    sm: 'px-2.5 py-1 text-xs',
    md: 'px-3 py-1.5 text-sm',
    lg: 'px-4 py-2 text-base'
  };
  return <span className={`
        inline-flex items-center gap-1.5 font-bold rounded-full border
        ${variants[variant]}
        ${sizes[size]}
        ${className}
      `} data-id="element-2494">
      {icon && <span className="flex-shrink-0" data-id="element-2495">{icon}</span>}
      {children}
    </span>;
}